import {createAction} from "@reduxjs/toolkit";
export const addColorFilterAttribute = createAction('colorFilter/addAttribute');
export const removeColorFilterAttribute = createAction('colorFilter/removeAttribute');
export const updateColorFilterDecayValues = createAction('colorFilter/updateDecayValues');
export const updateColorFilterParityValues = createAction('colorFilter/updateParityValues');
export const updateColorFilterValues = createAction('colorFilter/updateMinMaxValues');
export const clearAllFilters = createAction('colorFilter/clearAllFilters');